<template>
  <div class="list">

    <!-- Header -->
    <div class="list-header">
      <div class="list-header-about">
        <h3 class="list-header-about-title"> {{ naming }} </h3>
        <span class="list-header-about-subtitle"> {{ counter }} {{ $t('products') }} </span>
      </div>
      <sort-products />
    </div>
    <!---->

    <!-- Content -->
    <div class="list-content" v-if="products.length">
      <product-tile class="list-content-item"
                    v-for="product in products"
                    :product="product"
                    :key="product.entity_id"
      />
    </div>
    <div class="list-content" v-else>
      <product-tile-preloader v-for="item in preloaderItems" :key="item" />
    </div>
    <!---->

  </div>
</template>

<script>
import SortProducts from 'theme/components/core/blocks/Shop/Product/Sort/SortProducts'
import ProductTile from 'theme/components/core/blocks/Shop/Product/ProductTile'
import ProductTilePreloader from 'theme/components/theme/blocks/Home/Preloaders/ProductTilePreloader'
import { mapGetters } from 'vuex'
let lastHero = 0

export default {
  name: 'ProductsGrid',
  components: {
    ProductTilePreloader,
    ProductTile,
    SortProducts
  },
  props: {
    products: {
      type: null,
      required: true
    },
    columns: {
      type: [Number, String],
      required: true
    },

    // Category title
    naming: {
      type: String
    },

    // Count of children categories
    counter: {
      type: Number
    }
  },
  data () {
    return {
      preloaderItems: this.products.length
    }
  },
  computed: {
    ...mapGetters({
      currentPartnerCode: 'partners/getCurrentPartnerCode',
      currentPartner: 'partners/getCurrentPartner'
    })
  },
  methods: {
    wide (isOnSale, isNew, index) {
      let deltaCondition = index > 0 && ((index - 1) - lastHero) % 2 === 0
      let isHero = ((isOnSale === '1' || isNew === '1') && deltaCondition) || (index === this.products.length - 1 && (index - lastHero) % 2 !== 0)
      if (isHero) {
        lastHero = index
      }
      return isHero ? 'col-xs-12' : 'col-xs-6'
    }
  }
}
</script>

<style lang="scss" scoped>
  .list {
    &-header {
      margin: 25px 0 15px 0;

      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      @media only screen and (max-width: 465px) {
        flex-direction: column;
        align-items: flex-start;
      }

      &-about {
        &-title {
          margin: 0 0 10px 0;

          color: #111;
          font-size: 18px;
          font-weight: 600;
        }

        &-subtitle {
          color: #4a4a4a;
          font-size: 14px;
          font-weight: 400;
        }
      }

      &-sort {
        display: flex;
        align-items: center;

        &-title {
          margin-right: 10px;

          color: #9b9b9b;
          font-size: 14px;
          font-weight: 400;
        }
      }
    }

    &-content {
      display: flex;
      flex-wrap: wrap;

      &-item {
        width: calc(100% / 4 - 10px);

        @media only screen and (max-width: 768px) {
          width: calc(100% / 3 - 10px);
        }

        @media only screen and (max-width: 465px) {
          width: calc(100% / 2 - 10px);
        }
      }
    }
  }
</style>
